import React, { useState } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import elsterSubmissionAndDataChangeService from '@rd-web-markets/market/dist/services/claim_project_reports/elster_submission_and_data_change.service';
import FirstFastCheckDateEditModal from './FirstFastCheckDateEditModal';
import ElsterSubmissionAndDataChange from '@rd-web-markets/market/dist/technicalProof/submit_application/ElsterSubmissionAndDataChange';
const ProjectBody = _ref => {
  let {
    project,
    fetchAllProjetcs
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showDateEditModal, setShowDateEditModal] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const {
    updateSubmitStatus,
    submitStatus: lastSubmitStatus,
    interval: fetchSubmitStatusInterval
  } = elsterSubmissionAndDataChangeService.useUpdateCrud(project.id, '', setLoading, 'submittedProjectDateChangeApi', 'submittedProjectDateChangeStatusApi');
  const timesheetValue = () => {
    var _project$name_lists;
    return ((_project$name_lists = project.name_lists) === null || _project$name_lists === void 0 ? void 0 : _project$name_lists.length) > 0 ? t('filled_in') : t('need_to_be_updated');
  };
  const staffCostValue = () => {
    var _project$staff_costs;
    return ((_project$staff_costs = project.staff_costs) === null || _project$staff_costs === void 0 ? void 0 : _project$staff_costs.length) > 0 ? t('filled_in') : t('need_to_be_updated');
  };
  const renderAllInvoicesCollectedStatus = () => {
    if (project.all_invoices_collected_and_updated) {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-success"
      }, "done");
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-danger"
      }, "close");
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showDateEditModal && /*#__PURE__*/React.createElement(FirstFastCheckDateEditModal, {
    show: showDateEditModal,
    onHide: () => setShowDateEditModal(false),
    project: project,
    createSubmitStatus: updateSubmitStatus
  }), /*#__PURE__*/React.createElement(Row, {
    key: project.id,
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Link, {
    to: "".concat(location.pathname, "?main_tab=project_details&sub_tab1=employee&p_id=").concat(project.id)
  }, project.project_name)), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, createTimezonedDate(project.first_fast_check.lifetime_of_the_customer_project_from, true).toCustomLocaleDateString()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, createTimezonedDate(project.first_fast_check.lifetime_of_the_customer_project_to, true).toCustomLocaleDateString()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, project.bsfz_number), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, timesheetValue()), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, staffCostValue()), /*#__PURE__*/React.createElement(Col, {
    md: 1,
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, renderAllInvoicesCollectedStatus())), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, "To be added"), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setShowDateEditModal(true),
    disabled: loading || ['pending', 'not_started'].includes(lastSubmitStatus === null || lastSubmitStatus === void 0 ? void 0 : lastSubmitStatus.status),
    className: "ms-auto me-3",
    style: {
      width: '100%'
    }
  }, t('change_end_date'))), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(ElsterSubmissionAndDataChange, {
    setLoading: setLoading,
    loading: loading,
    createSubmitStatus: updateSubmitStatus,
    lastSubmitStatus: lastSubmitStatus,
    fetchSubmitStatusInterval: fetchSubmitStatusInterval,
    showRetryIfFailed: false,
    afterIntervalEndedCallback: fetchAllProjetcs,
    minimalDisplay: true
  }))));
};
export default ProjectBody;